import WidgetStore from './store'
export const widgetStore = new WidgetStore()
